export default __webpack_public_path__ + "static/media/logo-wordpress.18cfb609.png";